import { ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  token: {
    colorPrimary: "#0035cc",
  },
  components: {
    Statistic: {
      titleFontSize: 10,
      contentFontSize: 14,
    },
  },
};
